import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import MonacoCard from './MonacoCard';
import {
	getCurrencySymbol,
	loadStateSession,
	saveStateSession,
} from '../../../FlyfishComponents/flyfishutils/utils';
import Axios from 'axios';
import Modal from '../../../FlyfishComponents/Modal';
import MonacoModal from './MonacoModal';

const MonacoDiv = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 20px;
	& > .product-list {
		& > .category {
			display: flex;
			justify-content: center;
			margin: 32px 0;
			& > p {
				font-size: 16px;
				color: #080758;
				text-transform: uppercase;
				letter-spacing: 0.8px;
				font-family: Montserrat;
			}
		}
		& > .product-row {
			display: flex;
			gap: 10px;
			margin-bottom: 20px;
			& > .product {
				&.selected {
					border: 1px solid #585454;
				}
			}
		}
		& > .show-more {
			font-size: 12px;
			color: #020202;
			font-family: Montserrat !important;
			display: flex;
			justify-content: center;
			& > p {
				cursor: pointer;
				width: fit-content;
				border: 1px solid var(--black-20);
				padding: 8px 24px;
				color: var(--black-60);
			}
		}
	}
`;

const MonacoTheme = (props: any) => {
	const [monacoProducts, setMonacoProducts] = useState(
		props.metaData.products || []
	);
	const [monacoYMALProducts, setMonacoYMALProducts] = useState([]);
	const [monacoCategories, setMonacoCategories] = useState(
		props.metaData.categories || []
	);
	const [visibleRows, setVisibleRows] = useState(1);
	// Enable if want to call You may also like separately
	const [visibleYMALRows, setVisibleYMALRows] = useState(1);

	const productsPerRow =
		window.innerWidth <= 840
			? 2
			: window.innerWidth > 840 && window.innerWidth < 1366
				? 3
				: 4;
	const [llmproducts, setLLMProducts] = useState([]);
	// Enable if want to call You may also like separately
	// const [llmYMALproducts, setLLMYMALProducts] = useState([]);

	const [selectedProduct, setSelectedProduct] = useState(null);
	const [productModal, setProductModal] = useState(false);
	const [callOnce, setCallOnce] = useState(false);
	const [reasonData, setreasonData] = useState<any>('');
	const showMore = (category: string) => {
		if (category === monacoCategories[0]) {
			setVisibleRows(visibleRows + 1);
		} else {
			console.log('show', visibleYMALRows);
			setVisibleYMALRows(visibleYMALRows + 1);
		}
	};
	// Enable if want to call You may also like separately
	// const showYMALMore = () => {
	// 	setVisibleYMALRows(visibleYMALRows + 1);
	// };
	const displaySymbol = (currencyCode) => {
		return getCurrencySymbol(currencyCode);
	};
	useEffect(() => { }, [visibleRows]);
	useEffect(() => {
		setCallOnce(false);
		let productIdsArray = monacoProducts.map((eachItem, index) => {
			return eachItem.product_id;
		});
		let stringifyProductIDs = String(productIdsArray);
		stringifyProductIDs &&
			Axios.get(
				`${window['BASE_URL']}/shop/${props.tenantId
				}/products/price?productIds=${stringifyProductIDs}&country=${loadStateSession(
					'FS-countryCode'
				)}`,
				{
					headers: {
						'x-tenant-id': props.tenantId,
						Authorization: `Bearer ${props.token}`,
					},
				}
			).then((resp: any) => {
				let response = resp.data.response;
				let products = response.data.products;
				setLLMProducts(products);
			});
		// Enable if want to call You may also like separately
		// let payload = {
		// 	input_text: props.productData.message,
		// 	bot_id: props.productData.botId,
		// 	tenant_id: props.tenantId,
		// 	version: '',
		// 	conversationId: props.conversationId,
		// };
		// Axios.post(
		// 	`${window['BASE_URL']}/llmconnector/complimentary_products`,
		// 	payload,
		// 	{
		// 		headers: {
		// 			'x-tenant-id': props.tenantId,
		// 			Authorization: `Bearer ${props.token}`,
		// 		},
		// 	}
		// ).then((resp: any) => {
		// 	setMonacoYMALProducts(resp.data);
		// });
	}, []);
	// Enable if want to call You may also like separately
	// useEffect(() => {
	// 	if (monacoYMALProducts.length) {
	// 		let productIdsArray = monacoYMALProducts.map((eachItem, index) => {
	// 			return eachItem.product_id;
	// 		});
	// 		let stringifyProductIDs = String(productIdsArray);
	// 		stringifyProductIDs &&
	// 			Axios.get(
	// 				`${window['BASE_URL']}/shop/${
	// 					props.tenantId
	// 				}/products/price?productIds=${stringifyProductIDs}&country=${loadStateSession(
	// 					'FS-countryCode'
	// 				)}`,
	// 				{
	// 					headers: {
	// 						'x-tenant-id': props.tenantId,
	// 						Authorization: `Bearer ${props.token}`,
	// 					},
	// 				}
	// 			).then((resp: any) => {
	// 				let response = resp.data.response;
	// 				let products = response.data.products;
	// 				setLLMYMALProducts(products);
	// 			});
	// 	}
	// }, [monacoYMALProducts]);

	const setReasonData = (reason) => {
		setreasonData(reason);
	};
	const productSelection = (product) => {
		handleProductDetails(product.product_id)
		setSelectedProduct(
			product.product_id === selectedProduct ? null : product.product_id
		);
		props.handleSelectedProduct({
			productID: product.product_id,
			productName: product.title,
		});
		saveStateSession('FF-productID', product.product_id);
		setProductModal(true);
	};

	const handleProductDetails = (productId) => {
		setReasonData('');
		Axios.get(
			window['BASE_URL'] + `/conversation/tenant/${props.tenantId}/bot/${props.productData.botId}/recommendation_rational?text=${props.productData.message}&conversation_id=${props.productData.id}&message_id=${props.productData.messageId}&productId=${productId}`,
			{
				headers: {
					'Authorization': `Bearer ${loadStateSession('token')}`,
					'x-tenant-id': loadStateSession('tenantId') || loadStateSession('tenantID')
				}
			}

		).then((response) => {
			setReasonData(response.data.products[0].reason);
		});
	};
	return (
		<>
			<MonacoDiv className='ff-client-monaco-theme'>
				<div className='product-list'>
					{monacoCategories.map((category, categoryIndex) => {
						let products = monacoProducts.filter(
							(product) => product.category === monacoCategories[categoryIndex]
						);
						return (
							<>
								{category !== monacoCategories[0] && products.length ? (
									<div className='category'>
										<p>{category}</p>
									</div>
								) : null}

								{Array.from(
									{
										length:
											category === monacoCategories[0]
												? visibleRows
												: visibleYMALRows,
									},
									(_, rowIndex) => (
										<div
											className={`product-row ${props.selectedTheme}`}
											key={rowIndex}
										>
											{products
												.slice(
													rowIndex * productsPerRow,
													(rowIndex + 1) * productsPerRow
												)
												.map((product, index) => {
													let llmMatchedProduct: any = [];
													let price = product.price;
													let currency = product.currency;
													let imageOnHover = '';
													if (llmproducts.length) {
														llmMatchedProduct = llmproducts.length
															? llmproducts.filter(
																(v) => v.id === product.product_id
															)
															: '';

														if (llmMatchedProduct.length !== 0) {
															price =
																llmMatchedProduct && llmMatchedProduct[0].price;

															currency =
																llmMatchedProduct &&
																llmMatchedProduct[0].currency;
															imageOnHover = llmMatchedProduct[0].images.length
																? llmMatchedProduct[0].images[1]
																	? llmMatchedProduct[0].images[1] ===
																		product.media_link
																		? llmMatchedProduct[0].images[0]
																		: llmMatchedProduct[0].images[1]
																	: product.media_link
																: product.media_link;
														}
													}

													return (
														<div
															className={`product ${product.product_id === selectedProduct
																? 'selected'
																: ''
																}`}
															key={index}
															onClick={() => productSelection(product)}
														>
															<MonacoCard
																selectedProduct={
																	product.product_id === selectedProduct
																}
																key={index}
																title={product.title}
																price={price}
																currency={displaySymbol(currency)}
																header={product.header}
																mediaType={product.media_type}
																mediaLink={product.media_link}
																imageOnHover={imageOnHover}
															/>
														</div>
													);
												})}
										</div>
									)
								)}
								{category === monacoCategories[0]
									? (category === monacoCategories[0] ? visibleRows : 1) *
									productsPerRow <
									monacoProducts.filter(
										(product) => product.category === monacoCategories[0]
									).length && (
										<div
											className='show-more'
											onClick={() => showMore(category)}
										>
											<p>Show More</p>
										</div>
									)
									: null}
								{category.toLowerCase() === 'you may also like'
									? (category.toLowerCase() === 'you may also like'
										? visibleYMALRows
										: 1) *
									productsPerRow <
									monacoProducts.filter(
										(product) =>
											product.category.toLowerCase() === 'you may also like'
									).length && (
										<div
											className='show-more'
											onClick={() => showMore(category)}
										>
											<p>Show More</p>
										</div>
									)
									: null}
							</>
							// <>
							// 	{category !== 'You may also like' ? (
							//paste the above code here if want to call you may also like products separately
							// 	) : null}
							// </>
						);
					})}
					{/* {monacoYMALProducts && monacoYMALProducts.length > 1 ? (
						<>
							<div className='category'>
								<p>You may also like</p>
							</div>
							{Array.from(
								{
									length: visibleYMALRows,
								},
								(_, rowIndex) => (
									<div
										className={`product-row ${props.selectedTheme}`}
										key={rowIndex}
									>
										{monacoYMALProducts
											.slice(
												rowIndex * productsPerRow,
												(rowIndex + 1) * productsPerRow
											)
											.map((product, index) => {
												let llmMatchedProduct: any = [];
												let price = product.price;
												let currency = product.currency;
												let imageOnHover = '';
												if (llmYMALproducts.length) {
													llmMatchedProduct = llmYMALproducts.length
														? llmYMALproducts.filter(
																(v) => v.id === product.product_id
														  )
														: '';

													if (llmMatchedProduct.length !== 0) {
														price =
															llmMatchedProduct && llmMatchedProduct[0].price;

														currency =
															llmMatchedProduct &&
															llmMatchedProduct[0].currency;
														imageOnHover = llmMatchedProduct[0].images.length
															? llmMatchedProduct[0].images[1]
																? llmMatchedProduct[0].images[1]
																: product.media_link
															: product.media_link;
													}
												}

												return (
													<div
														className={`product ${
															product.product_id === selectedProduct
																? 'selected'
																: ''
														}`}
														key={index}
														onClick={() => productSelection(product)}
													>
														<MonacoCard
															selectedProduct={
																product.product_id === selectedProduct
															}
															key={index}
															title={product.title}
															price={price}
															currency={displaySymbol(currency)}
															header={product.header}
															mediaType={product.media_type}
															mediaLink={product.media_link}
															imageOnHover={imageOnHover}
														/>
													</div>
												);
											})}
									</div>
								)
							)}
							{visibleYMALRows * productsPerRow < monacoYMALProducts.length && (
								<div className='show-more' onClick={showYMALMore}>
									<p>Show More</p>
								</div>
							)}
						</>
					) : null} */}
				</div>
			</MonacoDiv>
			{productModal && (
				<Modal
					modalcontainerClassName='ff-product-overlay'
					footerNotReq={true}
					onClose={() => setProductModal(false)}
					headerCloseBtn
					headerCloseBtnIcon={
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='29.255'
							height='29.25'
							viewBox='0 0 29.255 29.25'
						>
							<g
								id='Icon_ion-ios-close-outline'
								data-name='Icon ion-ios-close-outline'
								transform='translate(-3.372 -3.375)'
							>
								<path
									id='Path_20510'
									data-name='Path 20510'
									d='M28.343,7.657a14.627,14.627,0,1,0,0,20.686,14.632,14.632,0,0,0,0-20.686Zm-.865,19.821a13.4,13.4,0,1,1,0-18.956A13.423,13.423,0,0,1,27.478,27.478Z'
								/>
								<path
									id='Path_20511'
									data-name='Path 20511'
									d='M23.92,11.25l-5.934,5.92L12.08,11.278l-.83.83L17.156,18,11.25,23.892l.83.83,5.906-5.892,5.934,5.92.83-.83L18.816,18l5.934-5.92Z'
								/>
							</g>
						</svg>
					}
					actionButtons={<></>}
					remove
				>
					<MonacoModal
						selectedTheme={props.selectedTheme}
						setReasonData={setReasonData}
						reasonData={reasonData}
						callOnce={callOnce}
						closeAPI={() => {
							setCallOnce(true);
						}}
						tenantId={props.tenantId}
						token={props.token}
						secondAPI={props.metaData.get_products}
						data={props}
						createCart={props.createCart}
						handleSelectedProduct={props.handleSelectedProduct}
						closeModal={() => {
							setProductModal(false);
						}}
						conversationId={props.conversationId}
					/>
				</Modal>
			)}
		</>
	);
};

export default MonacoTheme;
